module.exports = __webpack_public_path__ + "img/microsoft-logo.319d9b9a.svg";